import { render, staticRenderFns } from "./FileCell.vue?vue&type=template&id=56a66843&scoped=true&"
import script from "./FileCell.vue?vue&type=script&lang=js&"
export * from "./FileCell.vue?vue&type=script&lang=js&"
import style0 from "./FileCell.vue?vue&type=style&index=0&id=56a66843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a66843",
  null
  
)

export default component.exports